// Datum-helpers voor de ruil-UI: een 'YYYY-MM-DD'-string naar een menselijke NL-datum.
const WEEKDAG = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
const MAAND_NL = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

// 'YYYY-MM-DD' → "maandag 14 juli 2026" (lokale kalenderdatum; de weekdag is tz-onafhankelijk).
export function datumNL(iso) {
  if (!iso) return '';
  const [j, m, d] = String(iso).split('-').map(Number);
  if (!j || !m || !d) return String(iso);
  const datum = new Date(j, m - 1, d);
  return `${WEEKDAG[datum.getDay()]} ${d} ${MAAND_NL[m - 1]} ${j}`;
}
